import { render, staticRenderFns } from "./policy_category.vue?vue&type=template&id=aef68dfa"
import script from "./policy_category.vue?vue&type=script&lang=js"
export * from "./policy_category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports